import { AnimatePresence, motion } from 'motion/react';
import { useBookingContext } from '../../contexts/BookingContext';

export default function Container({ children, id }: { children: React.ReactNode; id: string }) {
	const { service } = useBookingContext();

	const transition = {
		duration: 0.25,
		animation: { ease: 'easeInOut' },
	};

	const variants = {
		hidden: { transform: 'translateX(2rem)', opacity: 0 },
		visible: { transform: 'translateX(0)', opacity: 1 },
		exit: { transform: 'translateX(-2rem)', opacity: 0 },
	};

	const classes = ['booking'];
	if (service.businessId && service.serviceId) {
		classes.push('booking--initialized');
	}

	return (
		<AnimatePresence>
			<motion.div className={classes.join(' ')} id={id} initial="hidden" animate="visible" exit="exit" variants={variants} transition={transition}>
				<div className={`booking__container booking__container--${id}`}>{children}</div>
			</motion.div>
		</AnimatePresence>
	);
}

export function Wrapper({ children }: { children: React.ReactNode }) {
	return <div className="booking__wrapper">{children}</div>;
}
